import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// NavigationDuplicated 当出现该错误时, 添加以下代码
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err) => err);
};
const routes = [
    {
        path: "/",
        name: "login",
        alias: "/login",
        component: () => import("../views/login/login.vue"),
    },
    {
        path: "/main",
        name: "main",
        redirect: "/main/productAdmin",
        component: () => import("../views/main.vue"),
        children: [
            {
                path: "userList",
                name: "userList",
                component: () => import("../views/userPage/userList.vue"),
            },
            {
                path: "userDetail",
                name: "userDetail",
                component: () => import("../views/userPage/userDetail.vue"),
            },
            {
                path: "pushManage",
                name: "pushManage",
                component: () => import("../views/pushPage/pushManage.vue"),
            },
            {
                path: "editPush",
                name: "editPush",
                component: () => import("../views/pushPage/editPush.vue"),
            },
            {
                path: "feedBack",
                name: "feedBack",
                component: () => import("../views/feedBack/feedBack.vue"),
            },
            {
                path: "feedbackDetail",
                name: "feedbackDetail",
                component: () => import("../views/feedBack/feedbackDetail.vue"),
            },
            {
                path: "management",
                name: "management",
                component: () => import("../views/management/management.vue"),
            },
            {
                path: "editor",
                name: "editor",
                component: () => import("../views/management/editor.vue"),
            },
            {
                path: "password",
                name: "password",
                component: () => import("../views/password/password.vue"),
            },
        ],
    },
    {
        path: "*",
        redirect: "/",
    },
];
const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    if (to.name === "login") {
        next();
    } else {
        // 导航栏的选中;
        if (to.name === "userList" || to.name === "userDetail") {
            sessionStorage.setItem("currentTab", "userList");
        } else if (to.name === "pushManage" || to.name === "editPush") {
            sessionStorage.setItem("currentTab", "pushManage");
        } else if (to.name === "feedBack" || to.name === "feedbackDetail") {
            sessionStorage.setItem("currentTab", "feedBack");
        } else if (to.name === "management" || to.name === "editor") {
            sessionStorage.setItem("currentTab", "management");
        } else if (to.name === "password") {
            sessionStorage.setItem("currentTab", "password");
        }
        next();
    }
});

export default router;
